import React,{useEffect,useState} from "react";
import { Outlet } from "react-router-dom";
import {useLocation } from "react-router-dom";
import Header from "../Components/Layout/Header";
import ChatBotWindow from "../Components/ChatBot/ChatBotWindow";
import { useChat } from '../Components/Layout/ChatContext';

const PrivateLayout = () => {
  const location = useLocation();
  const [showHeader, setShowHeader] = useState(false);
  const {isChatVisible, toggleChat, showChat } = useChat();

  useEffect(() => {
    // Show the header if the user navigates away from the homepage
    if (location.pathname !== '/welcomeform') {
      setShowHeader(true);
    } else {
      setShowHeader(false);
    }
  }, [location.pathname]);
  return (
    <>
      {/* Render the header */}
      {showHeader && <Header />}
      {isChatVisible && <ChatBotWindow />}
      {/* Render child routes */}
      <main className="container-fixed my-5 my-sm-1">
        <div className="row">
          <Outlet />
        </div>
      </main>
    </>
  );
};

export default PrivateLayout;
